<p-confirmDialog></p-confirmDialog>
<div class="container p-4">
	<!-- View Mode -->
	<div *ngIf="!editMode">
		<div
			*ngIf="loading"
			class="flex justify-content-center align-items-center h-20rem"
		>
			<p-progressSpinner></p-progressSpinner>
		</div>

		<div *ngIf="!loading">
			<div
				*ngIf="page"
				class="page-container"
			>
				<div class="view-header">
					<h1>{{ page.title }}</h1>
					<p-button
						icon="pi pi-pencil"
						styleClass="p-button-secondary p-button-text"
						(click)="enterEditMode()"
						[disabled]="disableEdit"
						*hasPermission="['pages.edit']"
					></p-button>
					<div class="spacer"></div>
					<div class="flex-container">
						<span
							*ngFor="let pageAlt of pagesWithDirectory"
							[pTooltip]="pageAlt.name"
							tooltipPosition="top"
							class="p-mr-2 zone-tag"
							[class.selectable]="pageAlt.id !== page?.id"
							[class.selected]="pageAlt.id === page?.id"
							[class.currentZone]="pageAlt.zone.id === currentZone?.id"
							(click)="setAlternative(pageAlt)"
						>{{pageAlt.zone.name}}</span>
					</div>
					<p-button
						icon="pi pi-trash"
						styleClass="p-button-danger p-button-text"
						(click)="confirmRemove()"
						[disabled]="disableRemove"
						*hasPermission="['pages.remove']"
					></p-button>
				</div>
				<quill-editor
					[readOnly]="true"
					[(ngModel)]="page.contents"
					format="json"
					[modules]="viewModules"
					class="view-editor"
				></quill-editor>
			</div>

			<div
				*ngIf="!page"
				class="not-found-container text-center p-4"
			>
				<div class="surface-card p-4 shadow-2 border-round">
					<h2 class="text-2xl font-bold mb-2">Page Not Found</h2>
					<p class="text-color-secondary mb-4">The page you are looking for at "{{ path }}" does not exist.
					</p>

					<p
						*ngIf="pagesWithDirectory?.length"
						class="text-color-secondary mb-4"
					>

						<span>
							Try these zones:
						</span>
						<span
							*ngFor="let pageAlt of pagesWithDirectory"
							[pTooltip]="pageAlt.name"
							tooltipPosition="top"
							class="p-mr-2 zone-tag"
							[class.selectable]="pageAlt.id !== page?.id"
							[class.selected]="pageAlt.id === page?.id"
							[class.currentZone]="pageAlt.zone.id === currentZone?.id"
							(click)="setAlternative(pageAlt)"
						>{{pageAlt.zone.name}}</span>
					</p>

					<p-button
						label="Create Page"
						icon="pi pi-plus"
						*hasPermission="['pages.create']"
						(click)="enterEditMode()"
					></p-button>
				</div>
			</div>
		</div>
	</div>

	<!-- Edit/Create Mode -->
	<div *ngIf="editMode">
		<div class="p-fluid">
			<div class="edit-header">
				<label
					for="title"
					class="title-label"
				>Title</label>
				<div class="actions">
					<p-button
						label="Cancel"
						styleClass="p-button-outlined p-button-secondary"
						(click)="cancelEdit()"
					></p-button>
					<p-button
						[label]="saveText"
						(click)="savePage()"
						*ngIf="!disableEdit"
					></p-button>
				</div>
			</div>
			<div class="p-field mb-4">
				<input
					id="title"
					type="text"
					pInputText
					[(ngModel)]="editTitle"
				>
			</div>
			<div class="p-field">
				<label
					for="contents"
					class="block text-xl font-bold mb-2"
				>Contents</label>
				<quill-editor
					[(ngModel)]="editContents"
					format="json"
					[style]="{'height': 'calc(100vh - 350px)'}"
					[modules]="editModules"
				></quill-editor>
			</div>
		</div>
	</div>
</div>